import { observer } from "mobx-react";
import * as React from "react";
import { FormUpdatePassword } from "../ui/molecules/form-update-password";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";
import { LengthUnitSelector } from "@/components/ui/length-unit-selector";
import { Label } from "@/components/ui/label";
import { LanguageSelector } from "@/parts/language-selector";
import type { LengthUnit } from "../api";

export const PageSettings = observer(() => {
    const lengthUnit = store.serviceOwnUser.user?.lengthUnit;
    const updateLengthUnit = async (lengthUnit?: LengthUnit): Promise<void> => {
        await store.repositoryUsers.updateLoggedInUser({ lengthUnit });
    };

    return (
        <FusionLayout breadcrumb={store.i18n.t("page.settings.title")}>
            <h3 className="my-2 text-2xl leading-normal font-bold">
                {store.i18n.t("page.settings.preferences.title")}
            </h3>
            <div className="my-2 flex flex-col gap-2">
                <Label>{store.i18n.t("page.settings.language.label")}</Label>
                <LanguageSelector />
            </div>
            <div className="my-2 flex flex-col gap-2">
                <Label>{store.i18n.t("page.settings.lengthUnit.label")}</Label>
                <LengthUnitSelector value={lengthUnit ?? undefined} onChange={updateLengthUnit} />
            </div>
            <h3 className="my-2 text-2xl leading-normal font-bold">
                {store.i18n.t("page.settings.passwordChange.title")}
            </h3>
            <FormUpdatePassword />
        </FusionLayout>
    );
});
